export const NF0 = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
export const clamp = (x) => (Number.isFinite(+x) ? +x : 0);

export function measures(state) {
    const rooms = state.rooms || [];
    return {
        floorAll: rooms.reduce((a, r) => a + (+r.area || 0), 0),
        tile: rooms.filter(r => r.floor === 'tile').reduce((a, r) => a + (+r.area || 0), 0),
        lam: rooms.filter(r => r.floor === 'lam').reduce((a, r) => a + (+r.area || 0), 0),
        warm: rooms.filter(r => r.warm).reduce((a, r) => a + (+r.area || 0), 0),
        wallAll: rooms.reduce((a, r) => a + (+r.wall || 0), 0),
        bathFloor: state.bathroom?.floorArea || 0,
        bathWallsWet: state.bathroom?.wetWallArea || 0,
        bathPerim: state.bathroom?.perim || 0,
    };
}
export const ceilPacks = (need, packSize) => {
    const p = Number.isFinite(+packSize) && +packSize > 0 ? +packSize : 1;
    const n = Number.isFinite(+need) ? +need : 0;
    return Math.ceil((n / p) * 1000) / 1000;
};
export function scopeBase(m, S, state) {
    switch (m.scope) {
        case 'floorAll': return S.floorAll;
        case 'tile': return S.tile;
        case 'lam': return S.lam;
        case 'warm': return S.warm;
        case 'wallsAll': return S.wallAll;
        case 'bathWalls': return S.bathWallsWet;
        case 'bathPerim': return S.bathPerim;
        case 'plinth': return state.params?.plinth_m || 0;
        default: return S.floorAll;
    }
}
